import React, { createContext, useContext } from "react";
import { getData } from "./Api";

const data = {
  loading: false,
  error: false,
  data: [],
};

const brimfieldReducer = (state, action) => {
    switch (action.type) {
        case "LOADING":
          return { ...state, loading: true, error: false };
        case "SUCCESS":
          return {
            ...state,
            loading: false,
            error: false,
            data: action.payload,
          };
          case "SUCCESS_IMAGES":
            return {
              ...state,
              loading: false,
              error: false,
              images: action.payload,
            };
        case "ERROR":
          return {
            ...state,
            loading: false,
            error: true,
          };
        case "CLEAR_IMAGES": 
          return {
            ...state,
            images: []
          }
        default:
          return state;
      }
    };

const BrimfieldContext = createContext();

export const BrimfieldProvider = ({ children }) => {
  const [brimfieldState, dispatch] = React.useReducer(brimfieldReducer, data);

  const getBrimfieldAssets = async () => {
    dispatch({ type: "LOADING" });
    try {
    const urlPath = `/assets?filter=brimfield`;
       await getData(urlPath).then((data) => {
             if (data?.type === "ERROR") { 
                 return dispatch({
                 type: "ERROR",
                 payload: data.payload
             })}
             return dispatch({
               type: "SUCCESS",
               payload: data.payload
             });
           });
         } catch (error) {
           return dispatch({
             type: "ERROR",
             payload: error,
           });
         }
       };

  return (
    <BrimfieldContext.Provider value={{ getBrimfieldAssets, brimfieldState }}>
      {children}
    </BrimfieldContext.Provider>
  );
};

export const useBrimfield = () => {
  const context = useContext(BrimfieldContext);

  if (!context) {
    return new Error("Provider required");
  }
  return context;
};
